import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function RoomRentModal({ show, handleClose, onSave, data }) {
  const [formData, setFormData] = useState({
    challan_no: "",
    total_amount: "",
    inrest_amount: "",
    collection_date: "",
    payment_type: "cash",
    nft: "",
  });
  const [loading, setLoading] = useState(false);
  const isEditMode = !!data;

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (data) {
      setFormData(data);
    } else {
      setFormData({
        challan_no: "",
        total_amount: "",
        inrest_amount: "",
        collection_date: new Date().toISOString().split("T")[0],
        payment_type: "cash",
        nft: "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const endpoint = isEditMode
      ? "/update-room-rent.php"
      : "/add-room-rent.php";
    const payload = isEditMode ? { ...formData, id: data.id } : formData;

    try {
      const response = await axios.post(`${API_URL}${endpoint}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        toast.success(`Data ${isEditMode ? "updated" : "added"} successfully!`);
        onSave();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "Edit" : "Add"} Room Rent Data</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Challan No</Form.Label>
            <Form.Control
              type="text"
              name="challan_no"
              value={formData.challan_no}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Total Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="total_amount"
                  value={formData.total_amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Interest Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="inrest_amount"
                  value={formData.inrest_amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Collection Date</Form.Label>
            <Form.Control
              type="date"
              name="collection_date"
              value={formData.collection_date}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Payment Type</Form.Label>
            <Form.Select
              name="payment_type"
              value={formData.payment_type}
              onChange={handleChange}
            >
              <option value="cash">Cash</option>
              <option value="online">Online</option>
            </Form.Select>
          </Form.Group>
          {formData.payment_type === "online" && (
            <Form.Group className="mb-3">
              <Form.Label>NFT/Transaction ID</Form.Label>
              <Form.Control
                type="text"
                name="nft"
                value={formData.nft}
                onChange={handleChange}
                required
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default RoomRentModal;
